import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { BodyLong01, ProductiveHeading06 } from 'components/styles';
import { useQueryIdps } from 'queries/saml';
import { LoginPolicy } from './login-policty';
import { SetupSamlDrawer } from './setup-saml-drawer';
import { SSOList } from './sso-list';

const SetupWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const SetupHeader = styled.h6`
  ${ProductiveHeading06};
`;

const SetupBody = styled.h1`
  ${BodyLong01};
`;

const Divider = styled.div`
  border: 1px solid var(--gray-10);
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
  border: 1px solid var(--gray-10);
  padding: var(--spacing-05) var(--spacing-06);
`;

export const SetupSaml: FC = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const { data: idps } = useQueryIdps();

  return (
    <Wrapper>
      <SetupWrapper>
        <div>
          <SetupHeader>
            <FormattedMessage id="settings.security.saml.title" />
          </SetupHeader>
          <SetupBody>
            <FormattedMessage id="settings.security.saml.body" />
            <a
              href="https://help.rocketlane.com/support/solutions/folders/67000573945"
              target="_blank"
              rel="noreferrer"
            >
              <FormattedMessage id="learn_more" />
            </a>
          </SetupBody>
        </div>
        {!idps?.length && (
          <Button type="primary" onClick={() => setShowDrawer(true)}>
            <FormattedMessage id="saml.setup.button" />
          </Button>
        )}
      </SetupWrapper>
      {idps?.length ? (
        <>
          <Divider />
          <LoginPolicy />
          <Divider />
          <SSOList />
        </>
      ) : null}
      <SetupSamlDrawer
        visible={showDrawer}
        onClose={() => setShowDrawer(false)}
      />
    </Wrapper>
  );
};
